import { render } from "./AlarmEdit.vue?vue&type=template&id=50421cb2&ts=true"
import script from "./AlarmEdit.vue?vue&type=script&lang=ts"
export * from "./AlarmEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__